export default {
  /**
   * @description token在Cookie中存储的天数，默认1天
   */
  cookieExpires: 1,
}


// WEBPACK FOOTER //
// ./src/config/index.js